import {
  dataServiceBaseUrl,
  mediasServiceBaseUrl,
} from "@coworker/app/src/core/cloud-services/cloud-services.helper";
import { isChineseEnvironment } from "@coworker/reusable/helpers/devices";
import { getEnvironmentId } from "@coworker/reusable/helpers/environment";

const isChina = isChineseEnvironment();

export const MEDIAS_SERVICE_URL = mediasServiceBaseUrl(
  getEnvironmentId(),
  isChina
);

export const DATA_SERVICE_URL = dataServiceBaseUrl(getEnvironmentId(), isChina);
